// Mock data for the landing page

export const heroSlides = [
  {
    image: 'https://customer-assets.emergentagent.com/job_851c8424-587a-44ab-b417-d2a09cb449a0/artifacts/nrfrh5uk_Gemini_Generated_Image_y7c7vey7c7vey7c7.png',
    title: 'Signature Collections',
    subtitle: 'CURATED LUXURY HAMPERS',
    cta: 'EXPLORE NOW',
  },
  {
    image: 'https://images.unsplash.com/photo-1722410180644-5955f83ec8b1?w=1920&q=80',
    title: 'Premium Collections',
    subtitle: 'CELEBRATE WITH GRACE',
    cta: 'DISCOVER',
  },
  {
    image: 'https://images.pexels.com/photos/28769884/pexels-photo-28769884.jpeg?w=1920&q=80',
    title: 'Thoughtful Gifting',
    subtitle: 'MADE WITH INTENTION',
    cta: 'SHOP NOW',
  },
];

export const collections = [
  {
    title: 'Signature Collections',
    description: 'Curated luxury gifts that tell a story',
    image: 'https://images.pexels.com/photos/3923073/pexels-photo-3923073.jpeg?w=800&q=80',
  },
  {
    title: 'Artisan Selection',
    description: 'Handcrafted pieces with soul',
    image: 'https://images.pexels.com/photos/32096880/pexels-photo-32096880.jpeg?w=800&q=80',
  },
  {
    title: 'Festive Gifting',
    description: 'Celebrate occasions with elegance',
    image: 'https://images.pexels.com/photos/28769884/pexels-photo-28769884.jpeg?w=800&q=80',
  },
];